import { useCallback, useContext, useEffect } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { selectSelectedEntityId } from "store/entity/selectors";

import { SocketContext } from "../../../../context/socket";

const WebSocketDownloadMatch = ({ downloads, handleWebhookStatusUpdate }) => {
  const { webhookSocket } = useContext(SocketContext);

  const handleStatusUpdate = useCallback(
    (payload) => {
      const streamId = payload?.data?.streamId;
      const status = payload?.data?.status;
      const progress = payload?.data?.jobDetails?.progress ?? 0;
      const id = payload?.data?.id;

      if (downloads.hasOwnProperty(`${streamId}_${id}`)) {
        handleWebhookStatusUpdate({ streamId, id, status, exportProgress: progress });
      }
    },
    [downloads, handleWebhookStatusUpdate],
  );

  useEffect(() => {
    webhookSocket.on(`core_job_status_update`, handleStatusUpdate);

    return () => {
      webhookSocket.off(`core_job_status_update`, handleStatusUpdate);
    };
  }, [handleStatusUpdate, webhookSocket]);

  return null;
};

const mapStateToProps = createStructuredSelector({
  entityId: selectSelectedEntityId,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(WebSocketDownloadMatch);
